<template>
    <div>

        <v-row dir="rtl" style="margin-right: 20px;" >
            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                <v-text-field
                        v-model="date_day"
                        @keypress="isNumber"
                        dense
                        maxlength="2"
                        outlined
                        :id="first_id+'date_day'"
                        v-on:keyup.enter="another_focus_select(first_id+'date_month')"
                />
            </v-col>
            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                <v-text-field
                        v-model="date_month"
                        @keypress="isNumber"
                        dense
                        maxlength="2"

                        outlined
                        :id="first_id+'date_month'"
                        v-on:keyup.enter="another_focus_select(first_id+'date_year')"
                />

            </v-col>
            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                <v-text-field
                        v-model="date_year"
                        @keypress="isNumber"
                        dense
                        maxlength="4"

                        outlined
                        :id="first_id+'date_year'"
v-on:keyup.enter="call_last_focus()"
                />

            </v-col>
            <v-col style="color:red;text-align: right" cols="6" v-if="jalali_to_miladi(state)=='Invalid date'">تاریخ اشتباه می باشد</v-col>
        </v-row>


    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        name: 'OriginDownload',
        components: {
        },
        events:{
          last_focus:bus,
        },
        props: {
            first_id:String,
            value:String,
        },
        data() {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                date_day: '',
                date_month: '',
                date_year: '',
                state: this.value,


            }
        },
        mounted() {
            console.log("three date doc_date", this.state)

            // if (this.three_doc_date == "" || ) {
            //     this.three_doc_date = this.get_today()
            //     this.date_year = this.get_today_array()[0]
            //     this.date_month = this.get_today_array()[1]
            //     this.date_day = this.get_today_array()[2]
            //
            // } else {
            //     console.log("three doc date not null ", this.three_doc_date)
            this.date_year = this.value.split("/")[0]
            this.date_month = this.value.split("/")[1]
            this.date_day = this.value.split("/")[2]
            //
            // }

        },
        watch: {
            'value': function () {
                console.log("three date vlaue", this.value)

                // localStorage.setItem("delivery_doc_date", this.doc_date);
                this.date_year = this.value.split("/")[0]
                this.date_month = this.value.split("/")[1]
                this.date_day = this.value.split("/")[2]
            },
            'state': function () {
                console.log("three date state", this.state)

                // localStorage.setItem("delivery_doc_date", this.doc_date);
                this.date_year = this.value.split("/")[0]
                this.date_month = this.value.split("/")[1]
                this.date_day = this.value.split("/")[2]
            },
            'date_day': function () {
                console.log("three date  date_day changed", this.date_day)
                this.state = this.date_year + "/" + this.date_month + "/" + this.date_day
                this.$emit('input', this.state)

            },
            'date_month': function () {
                console.log("three date date_month changed", this.date_month)
                this.state = this.date_year + "/" + this.date_month + "/" + this.date_day
                this.$emit('input', this.state)

            },
            'date_year': function () {
                console.log("three date date_year changed", this.date_year)
                this.state = this.date_year + "/" + this.date_month + "/" + this.date_day
                this.$emit('input', this.state)

            },
        },
        computed: {},
        methods: {
            call_last_focus(){
                this.$emit('last_focus', this.value)
            }
        }
    }
</script>
